function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import { EXTENSION_STATUS_INDICATOR_STATUS } from '../../../../../../../components/shared/constants/subscriptions.constants';
import LocaleKeys from '../../../../../../../locales/keys';
export var SubscriptionExtensionRemoveListPopupController = /*#__PURE__*/function () {
  function SubscriptionExtensionRemoveListPopupController() {
    _classCallCheck(this, SubscriptionExtensionRemoveListPopupController);
  }
  return _createClass(SubscriptionExtensionRemoveListPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.LocaleKeys = LocaleKeys;
      this.ExtensionStatus = EXTENSION_STATUS_INDICATOR_STATUS;
      var columnDefs = [{
        field: 'Radio',
        displayName: '',
        width: '50',
        resizable: false,
        enableSorting: false,
        enableColumnMoving: false,
        cellTemplate: require('./cellTemplates/extension.template.html')
      }, {
        field: 'PricingPlanName',
        displayName: i18n.translate(LocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.EXTENSION),
        resizable: false,
        enableSorting: false,
        enableColumnMoving: false,
        width: '*'
      }, {
        field: 'Status',
        displayName: i18n.translate(LocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.STATUS),
        width: '120',
        resizable: false,
        enableSorting: false,
        enableColumnMoving: false,
        cellTemplate: require('./cellTemplates/status.template.html')
      }, {
        field: 'StartDate',
        displayName: i18n.translate(LocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.START_DATE),
        width: '120',
        resizable: false,
        enableSorting: false,
        enableColumnMoving: false,
        cellTemplate: require('./cellTemplates/start.date.template.html')
      }, {
        field: 'EndDate',
        displayName: i18n.translate(LocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.END_DATE),
        width: '120',
        resizable: false,
        enableSorting: false,
        enableColumnMoving: false,
        cellTemplate: require('./cellTemplates/end.date.template.html')
      }];
      this.dataTable = {
        data: [],
        appScopeProvider: this,
        onRegisterApi: function onRegisterApi(event) {
          _this.gridApi = event.grid.api;
        },
        columnDefs: columnDefs
      };
      this.closeExtensionToRemovePopup = function () {
        _this.onClose()();
      };
      this.handleKeypressForm = function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          _this.submitExtensionToRemove();
        }
      };
      this.submitExtensionToRemove = function () {
        _this.onSuccess()(_this.extensionToRemove);
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.extensions) {
        if (this.extensions && this.extensions.length && this.dataTable) {
          this.dataTable.data = this.extensions;
          this.extensionToRemove = this.extensions[0].Id;
        }
      }
    }
  }]);
}();
export default {
  template: require('./subscription.extension.remove.list.popup.html'),
  controller: SubscriptionExtensionRemoveListPopupController,
  bindings: {
    extensions: '<',
    onClose: '&',
    onSuccess: '&'
  }
};